import { createSignal } from '@verclam/pulsar';

export type StaffMemberSidebarContext = {
	readonly staffMemberId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the staff member carried by `staffMemberId`; a
 * `staffMemberId` of `null` inside an open context creates one instead.
 */
const staffMemberSidebarSignal = createSignal<StaffMemberSidebarContext | null>(null);

export const openStaffMemberSidebar = (staffMemberId: number | null): void => {
	staffMemberSidebarSignal.value = { staffMemberId };
};

export const closeStaffMemberSidebar = (): void => {
	staffMemberSidebarSignal.value = null;
};

export default staffMemberSidebarSignal;
